// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Granted-OAuth-scopes panel (shared admin component) ──
   Used by UserDetail and SocialAccounts admin pages. The two
   page-level files (UserDetail.css, SocialAccounts.css) keep their
   own button / header chrome; this file owns only the inner panel. */

.scopes-panel {
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  font-size: 0.85rem;
}

.scopes-panel-disconnected {
  background: #f1f5f9;
  color: #64748b;
  font-style: italic;
}

.scopes-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.scopes-panel-title {
  font-weight: 600;
  color: #334155;
}

.scopes-panel-token-type {
  font-size: 0.78rem;
  color: #64748b;
  background: #e2e8f0;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
}

.scopes-panel-error {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  font-size: 0.82rem;
}

.scopes-panel-row {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.25rem 0;
}

.scopes-panel-label {
  color: #64748b;
  flex-shrink: 0;
}

.scopes-panel-value {
  color: #1e293b;
  text-align: right;
  word-break: break-word;
}

.scopes-pill {
  font-weight: 500;
  font-size: 0.82rem;
}

.scopes-pill-ok {
  color: #059669;
}

.scopes-pill-bad {
  color: #dc2626;
}

.scopes-panel-block {
  margin-top: 0.6rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e2e8f0;
}

.scopes-panel-block-title {
  font-weight: 600;
  margin-bottom: 0.4rem;
  color: #334155;
}

.scopes-panel-block-missing .scopes-panel-block-title {
  color: #991b1b;
}

.scopes-panel-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.scope-tag {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.78rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  border: 1px solid transparent;
}

.scope-tag-ok {
  background: #d1fae5;
  color: #065f46;
  border-color: #6ee7b7;
}

.scope-tag-missing {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.scope-tag-extra {
  background: #e0e7ff;
  color: #3730a3;
  border-color: #a5b4fc;
}

.scopes-panel-hint {
  margin-top: 0.5rem;
  font-size: 0.78rem;
  color: #64748b;
  font-style: italic;
  line-height: 1.4;
}

.scopes-panel-granular summary {
  cursor: pointer;
  font-weight: 600;
  color: #334155;
  padding: 0.25rem 0;
}

.scopes-granular-list {
  margin-top: 0.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.scopes-granular-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.78rem;
  background: #fff;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.scopes-granular-scope {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #1e293b;
}

.scopes-granular-targets {
  color: #64748b;
  font-size: 0.74rem;
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/ScopesPanel.css"],"names":[],"mappings":"AAAA;;;qEAGqE;;AAErE;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6EAA6E;EAC7E,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* ── Granted-OAuth-scopes panel (shared admin component) ──\n   Used by UserDetail and SocialAccounts admin pages. The two\n   page-level files (UserDetail.css, SocialAccounts.css) keep their\n   own button / header chrome; this file owns only the inner panel. */\n\n.scopes-panel {\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n\n.scopes-panel-disconnected {\n  background: #f1f5f9;\n  color: #64748b;\n  font-style: italic;\n}\n\n.scopes-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.scopes-panel-title {\n  font-weight: 600;\n  color: #334155;\n}\n\n.scopes-panel-token-type {\n  font-size: 0.78rem;\n  color: #64748b;\n  background: #e2e8f0;\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n}\n\n.scopes-panel-error {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  margin-bottom: 0.5rem;\n  font-size: 0.82rem;\n}\n\n.scopes-panel-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.25rem 0;\n}\n\n.scopes-panel-label {\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.scopes-panel-value {\n  color: #1e293b;\n  text-align: right;\n  word-break: break-word;\n}\n\n.scopes-pill {\n  font-weight: 500;\n  font-size: 0.82rem;\n}\n\n.scopes-pill-ok {\n  color: #059669;\n}\n\n.scopes-pill-bad {\n  color: #dc2626;\n}\n\n.scopes-panel-block {\n  margin-top: 0.6rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.scopes-panel-block-title {\n  font-weight: 600;\n  margin-bottom: 0.4rem;\n  color: #334155;\n}\n\n.scopes-panel-block-missing .scopes-panel-block-title {\n  color: #991b1b;\n}\n\n.scopes-panel-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.scope-tag {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.78rem;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid transparent;\n}\n\n.scope-tag-ok {\n  background: #d1fae5;\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n\n.scope-tag-missing {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.scope-tag-extra {\n  background: #e0e7ff;\n  color: #3730a3;\n  border-color: #a5b4fc;\n}\n\n.scopes-panel-hint {\n  margin-top: 0.5rem;\n  font-size: 0.78rem;\n  color: #64748b;\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.scopes-panel-granular summary {\n  cursor: pointer;\n  font-weight: 600;\n  color: #334155;\n  padding: 0.25rem 0;\n}\n\n.scopes-granular-list {\n  margin-top: 0.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.scopes-granular-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.78rem;\n  background: #fff;\n  padding: 0.3rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.scopes-granular-scope {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #1e293b;\n}\n\n.scopes-granular-targets {\n  color: #64748b;\n  font-size: 0.74rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
